"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("../../../libs/hooks");

var Checkmark = function Checkmark(props) {
  var className = props.className,
      style = props.style;

  var _useTheme = (0, _hooks.useTheme)(),
      palette = _useTheme.rainbow.palette;

  var color = (0, _react.useMemo)(function () {
    return {
      background: palette.brand.main,
      foreground: palette.getContrastText(palette.brand.main)
    };
  }, [palette]);
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: className,
    style: style,
    width: "1rem",
    height: "1rem",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "components"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    fill: color.background,
    cx: "10",
    cy: "10",
    r: "10"
  }), /*#__PURE__*/_react["default"].createElement("polyline", {
    transform: "scale(0.6) translate(4, 5.2)",
    stroke: color.foreground,
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    points: "20 6 9 17 4 12"
  })));
};

Checkmark.propTypes = {
  className: _propTypes["default"].string,
  style: _propTypes["default"].object
};
Checkmark.defaultProps = {
  className: undefined,
  style: undefined
};
var _default = Checkmark;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/PathStep/icons/checkMark.js
// module id = eAz5
// module chunks = 0